const state = {
  topHabilidades: [],
  outrasHabilidades: []
}

const getters = {
  topHabilidades: state => state.topHabilidades,
  outrasHabilidades: state => state.outrasHabilidades,
  
  // Formata top habilidades para o formato do pódio
  podiumHabilidades: state => {
    // Filtra apenas habilidades com nome preenchido
    return state.topHabilidades
      .filter(item => item.habilidadeNome && item.habilidadeNome.trim() !== '')
      .map((item) => ({
        skill: item.habilidadeNome,
        posicao: item.posicao || 1,
        filled: getNivelStars(item.nivel),
        filledColor: getCorHex(item.corSelecionada)
      }))
  },
  
  // Formata outras habilidades para lista
  listaHabilidades: state => {
    return state.outrasHabilidades
      .filter(item => item.label && item.label.trim() !== '') // Filtra apenas habilidades com nome
      .map(item => ({
        skill: item.label,
        level: item.nivel || 'Iniciando'
      }))
  },
  
  // Extrai tags únicas das habilidades
  tagsHabilidades: state => {
    const todasHabilidades = [
      ...state.topHabilidades.map(h => h.habilidadeNome),
      ...state.outrasHabilidades.map(h => h.label)
    ].filter(Boolean)
    
    return [...new Set(todasHabilidades)].map((name, index) => ({
      id: index + 1,
      name
    }))
  }
}

const mutations = {
  SET_TOP_HABILIDADES(state, habilidades) {
    state.topHabilidades = habilidades
  },
  
  SET_OUTRAS_HABILIDADES(state, habilidades) {
    state.outrasHabilidades = habilidades
  }
}

const actions = {
  atualizarTopHabilidades({ commit }, habilidades) {
    commit('SET_TOP_HABILIDADES', habilidades)
  },
  
  atualizarOutrasHabilidades({ commit }, habilidades) {
    commit('SET_OUTRAS_HABILIDADES', habilidades)
  }
}

// Funções auxiliares
function getNivelStars(nivel) {
  const niveis = {
    'Iniciando': 0,
    'Aprendiz': 1,
    'Praticante': 2,
    'Profissional': 3,
    'Professor': 4,
    'Mestre': 5
  }
  return niveis[nivel] || 0
}

function getCorHex(cor) {
  const cores = {
    'Amarelo': '#facc15',
    'Azul': '#60a5fa',
    'Roxo': '#c084fc',
    'Verde': '#4ade80',
    'Vermelho': '#f87171',
    'Rosa': '#f472b6'
  }
  return cores[cor] || '#facc15'
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
